import { gsap } from 'gsap';

const init = () => {
  const hotelListItems = document.querySelectorAll('.js-hotelAccordion');
  if (!hotelListItems) return;

  const accordionOpen = (item) => {
    item.setAttribute('data-open', 'true');
    const contentElement = item.querySelector('.js-hotelAccordionContent');
    const contentElementHeight = contentElement.scrollHeight;
    gsap.to(contentElement, {
      height: contentElementHeight,
      duration: 0.3,
      ease: "power1.inOut",
    });
  };

  const closeAccordions = (item) => {
    item.setAttribute('data-open', 'false');
    gsap.to(item.querySelector('.js-hotelAccordionContent'), {
      height: 0,
      duration: 0.3,
      ease: "power1.inOut",
    });
  };

  // ページにアクセスした際のハッシュリンク処理
  const url = new URL(window.location.href);
  const hash = url.hash.replace('#', '');
  hotelListItems.forEach((item) => {
    const itemArea = item.getAttribute('id');
    if(hash && itemArea === hash) {
      hotelListItems.forEach((otherItem) => {
        if (otherItem !== item) {
          closeAccordions(otherItem);
        }
      });
      accordionOpen(item);
    }
  });

  // アンカーリンク処理
  const mapAnchorLinks = document.querySelectorAll('.js-mapAnchorLink');
  mapAnchorLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      const hash = href.replace('#', '');
      hotelListItems.forEach((item) => {
        const itemArea = item.getAttribute('id');
        if(hash && itemArea === hash) {
          hotelListItems.forEach((otherItem) => {
            if (otherItem !== item) {
              closeAccordions(otherItem);
            }
          });
          accordionOpen(item);
        }
      });
    });
  });

  hotelListItems.forEach((item) => {
    let status = item.getAttribute('data-open');

    if (status === 'true') {
      accordionOpen(item);
    }

    const buttonElement = item.querySelector('.js-hotelAccordionButton');
    buttonElement.addEventListener('click', () => {
      hotelListItems.forEach((otherItem) => {
        if (otherItem !== item) {
          closeAccordions(otherItem);
        }
      });

      status = item.getAttribute('data-open');
      if (status === 'true') {
        closeAccordions(item);
      } else {
        accordionOpen(item);
      }
    });
  });
};

export {
  init
}
